export default __webpack_public_path__ + "static/media/ThankYou.b48043aa.svg";